'use strict';

var React = require('react');
var styled = require('styled-components');
var keyboard = require('../../../helpers/keyboard.js');
var dom = require('../../../helpers/dom.js');
var component = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var header_styles = require('./header.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const IconFilter = (props) => React__default.default.createElement(component.Icon, { name: "filter-filled", size: "m", ...props });
const IconFilterStyled = styled__default.default(IconFilter) `
  margin-left: ${({ theme }) => theme.space.table.xs};
  width: ${({ theme }) => theme.space.table.xxl};
  height: ${({ theme }) => theme.space.table.xxl};
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.primary.normal : 'inherit')};
`;
const GrabColContainer = styled__default.default.div `
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: ${({ theme }) => theme.space.table.m};
  display: flex;
  justify-content: center;
  ${({ $enable }) => ($enable ? 'cursor: col-resize;' : '')}
`;
const GrabColStyled = styled__default.default.div `
  border-right: 1px solid white;
  height: calc(100% + 1px);
`;
const GrabCol = ({ resize }) => {
    if (resize.hide) {
        return null;
    }
    const isEnable = resize.enable === undefined || resize.enable;
    return (React__default.default.createElement(GrabColContainer, { "$enable": isEnable, onMouseDown: isEnable ? resize.resizeMouseDown : undefined, onClick: e => e.stopPropagation() },
        React__default.default.createElement(GrabColStyled, null)));
};
const HeaderDefault = React.forwardRef(({ children, resize, asDiv = false, ...props }, ref) => {
    if (asDiv) {
        return React__default.default.createElement("div", { ...props }, children);
    }
    return (React__default.default.createElement(header_styles.HeaderStyled, { ref: ref, ...props },
        children,
        React__default.default.createElement(GrabCol, { resize: resize })));
});
function getElementByXPath(selector, scope = document) {
    const a = document.evaluate(selector, scope, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
    return a.snapshotLength > 0 ? a.snapshotItem(0) : null;
}
const HeaderWithFilter = ({ id, filter, filterKey, isFilterActive, setFilterActive, addToCurrentSort, removeFromCurrentSort, initialSort, children, isFirstCol, ...props }) => {
    const [isFilterOpen, setIsFilterOpen] = React.useState(false);
    const [endColumn, setEndColumn] = React.useState(false);
    const headerRef = React.useRef(null);
    const popinRef = React.useRef(null);
    const closeFilter = (e) => {
        if ((headerRef && headerRef.current && headerRef.current.contains(e.target)) ||
            (popinRef && popinRef.current && popinRef.current.contains(e.target)) ||
            dom.isWithinRefElement(e.target, popinRef)) {
            return;
        }
        setIsFilterOpen(false);
    };
    const onOpenFilter = (e) => {
        if (headerRef && headerRef.current) {
            if (!isFilterOpen) {
                const modalAncestor = getElementByXPath("./ancestor::div[@role='dialog']", headerRef.current);
                const filterWidth = 300;
                const filterBoundingRect = headerRef.current.getBoundingClientRect();
                const isInEndColumn = modalAncestor
                    ? modalAncestor.offsetLeft + modalAncestor.offsetWidth - filterBoundingRect.x < filterWidth
                    : (document?.body?.offsetWidth ?? 0) - filterBoundingRect.x < filterWidth;
                setEndColumn(isInEndColumn);
                setIsFilterOpen(true);
            }
            else if (!dom.isWithinRefElement(e.target, popinRef)) {
                setIsFilterOpen(false);
            }
        }
    };
    React.useEffect(() => {
        document.addEventListener('mousedown', closeFilter);
        document.addEventListener('keydown', (e) => {
            if (keyboard.isKey('enter')(e)) {
                setIsFilterOpen(false);
            }
        });
        return () => {
            document.removeEventListener('mousedown', closeFilter);
            document.removeEventListener('keydown', closeFilter);
        };
    }, []);
    const filterPopinComponent = React.useMemo(() => React__default.default.cloneElement(filter, {
        id: `filter-${id}`,
        filter: filterKey,
        node: popinRef,
        isFilterOpen,
        endColumn,
        isFirstCol,
        isFilterActive,
        setFilterActive,
        addToCurrentSort,
        removeFromCurrentSort,
        initialSort,
    }), [isFilterOpen, endColumn, isFilterActive]);
    return (React__default.default.createElement(HeaderDefault, { id: id, ref: headerRef, onClick: onOpenFilter, ...props },
        React__default.default.createElement(header_styles.HeaderFilterContainerStyled, null,
            React__default.default.createElement("span", null, children),
            React__default.default.createElement(IconFilterStyled, { "$isActive": isFilterActive })),
        React__default.default.createElement("div", null, filterPopinComponent)));
};
const Header = ({ filter, filterKey, setFilterActive = () => null, addToCurrentSort = () => null, removeFromCurrentSort = () => null, initialSort, isFilterActive = false, children, ...props }) => {
    if (filter && filterKey) {
        return (React__default.default.createElement(HeaderWithFilter, { ...props, filter: filter, filterKey: filterKey, isFilterActive: isFilterActive, setFilterActive: setFilterActive, addToCurrentSort: addToCurrentSort, removeFromCurrentSort: removeFromCurrentSort, initialSort: initialSort }, children));
    }
    return (React__default.default.createElement(HeaderDefault, { ...props },
        React__default.default.createElement(header_styles.HeaderContainerStyled, null, children)));
};

exports.GrabColContainer = GrabColContainer;
exports.GrabColStyled = GrabColStyled;
exports.Header = Header;
exports.IconFilterStyled = IconFilterStyled;
//# sourceMappingURL=header.js.map
